import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import { AUTH_LOCAL_STORAGE_KEY } from "../../../app/modules/auth";
import { Toaster } from "react-hot-toast";
import Moment from "moment";
import $ from "jquery";
import { Component, createRef } from "react";
import {
  getMachines,
  updateMachineIsActiveStatus
} from "../../models/_machine";
import { KTSVG } from "../../../_metronic/helpers";
import _ from "lodash";
import "react-datetime/css/react-datetime.css";
import { DownloadExcel } from "../ExcelHelper";
import { EditMachine } from './EditMachine';
import ChangeLocationModal from './ChangeLocationModal'
import AssignLocationModal from './AssignLocationModal'
import BarCodeModal from './BarCodeModal'
import { getModuleDataDisplaySettingByKey, updateModuleDataDisplaySettingByKey } from "../../models/_user";
import ViewStatusModel from "./ViewStatusModel"
import Columns from '../../../_metronic/helpers/Columns';
import { Tooltip } from "react-tooltip";
import MachineFilter from "./MachineFilter";
import Breadcrumb from "../Common/Breadcrumb";
import { IconPickerItem } from "react-fa-icon-picker";
import ReactDOMServer from "react-dom/server";
export const statusDB = [
  {
    id: "true",
    name: "Active",
  },
  {
    id: "false",
    name: "Inactive",
  },
  {
    id: "all",
    name: "All"
  }
];
export const ReplaceDB= [
  {
    id: true,
    name: "True",
  },
  {
    id: false,
    name: "False",
  },
];
export const addHouseClampsDB= [
  {
    id: "true",
    name: "Yes",
  },
  {
    id: "false",
    name: "No",
  },
];
export const isVipDB= [
  {
    id: "true",
    name: "Yes",
  },
  {
    id: "false",
    name: "No"
  },
  {
    id: "all",
    name: "All"
  }
];
const LOCAL_STORAGE_FILTER_KEY = 'service_portal_prod_machine_filter';
const LOCAL_STORAGE_PAGINATION_KEY = 'service_portal_prod_machine_pagination';
class MachinesList extends Component<any, any> {
  readonly props: any;
  constructor(props: any, state: any) {
    super(props);
    // Load saved filters and pagination from localStorage
    const savedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_FILTER_KEY) || "{}");
    const savedPage = parseInt(localStorage.getItem(LOCAL_STORAGE_PAGINATION_KEY) || "0", 10);
   
    const defaultFilters = {
      filterFromDate: "",
      filterToDate: "",
      filterBoard:[],
      filterTubeShield: [],
      filterLedRings: [],
      filterManager:"",
      filterName:"",
      filterCupHolder:[],
      filterStatus: "true",
      filterBlender:[],
      filterLocation: [],
      filterAddHouseClamps: "",
      filterPendingInstallation:"true",
      filterIsVip: undefined, 
      filterIsPolyfuses :"",
      filterMacAddress: "",
      filterMarketSegement:  [],
      filterMechanicalHardwareVersion: "",
      filterSerialNumber:  "",
      filterRegionId: [],
      filterDeploymentManagerId:  [],
      filterMachineStatus: [],
      filterLocationType:[],
      filterInStock: "",
      filterCustomer:[],
      applyDateFilterOn:""
    };

    this.state = {
      ...defaultFilters, // Use default filters if savedFilters is empty
      ...savedFilters,   // Overwrite with saved filters if available
      page: savedPage || 0, // Load saved page or default to 0
      resetStatus: createRef(),
      resetFrom: createRef(),
      resetTo: createRef(),
      resetMechanicalHardwareVersion: createRef(),
      resetAddHouseClamps: createRef(),
      resetIsVip: createRef(),
      resetIsPolyfuses: createRef(),
      filterManager: "",
      locationSelected: null,
      locationTypeSelected: null,
      addLoading: false,
      filterLoading: false,
      downloadLoading: false,
      barCodeModal: false,
      machineEditModal: false,
      loading: false,
      machineList: [],
      machineListObj: {},
      managerSelected: null,
      blenderSelected: null,
      tubeShiledSelected: null,
      ledRingsSelected: null,
      boardSelected: null,
      cupHolderSelected:null,
      changeLocationModal: false,
      assignLocationModalOpen: false,
      viewStatusModelOpen: false,
      machineStatusSelected: null,
      locationTypeDB:[],
      hardwareVersionsList: [],
      locationDB: [],
      locationRegionDB: [],
      blenderDB: [],
      boardDB: [],
      tubeShieldDB: [],
      ledRingsDB: [],
      cupHolderDB:[],
      managerDB: [],
      machinesDB: [],
      machineStatusDB: [],
      marketSegmentDB: [],
      marketSegmentIdSelected: [],
      customerDB:[],
      customerSelected:[],
      applyDateFilterOn:"",
      onlyRetired: false,
      inStock: "",
      locationRegionSelected: null,
      deploymentManagerSelected: null,
      perPage: 50,
      sorting: "ASC",
      moduleKeyName: 'machine_list',
      selectedColumns: [],
      columnData: [
        { id: 0, label: 'Machine Id', key: 'index' },
        { id: 1, label: 'Location Name', key: 'locationName' },
        { id: 2, label: 'Mac Address', key: 'macAddress' },
        { id: 3, label: 'Serial Number', key: 'serialNumber' },
        { id: 4, label: 'Machine Name', key: 'machineName' },
        { id: 5, label: 'Deployment Date', key: 'deploymentDate' },
        { id: 6, label: 'Deployed By', key: 'deployedBy' },
        { id: 7, label: 'Machine Status', key: 'machineStatus' },
        { id: 8, label: 'Remark', key: 'remark' },
        { id: 9, label: 'Software Version', key: 'softwareVersion' },
        { id: 10, label: 'Mechanical Hardware Version', key: 'hardwareVersion' },
        { id: 12, label: 'Has polyfuses?', key: 'isPolyfuses' },
        { id: 13, label: 'Created At', key: 'createdAt' },
        { id: 14, label: 'Retired At', key: 'retiredAt' },
        { id: 15, label: 'Retired By', key: 'retiredBy' },
        { id: 16, label: 'Blender', key: 'blender' },
        { id: 17, label: 'Board', key: 'board' },
        { id: 18, label: 'Last Sanitize At', key: 'lastSanitizeTime' },
        { id: 19, label: 'Last Heartbeat At', key: 'lastHearbeatSyncAt' },
        { id: 20, label: 'Last Sanitizer Replaced At', key: 'lastSanitizerReplacedAt' },
        { id: 21, label: 'Last Blade Replaced At', key: 'lastBladeReplaceAt' },
        { id: 22, label: 'Last Filter Replaced At', key: 'lastFilterReplacedAt' },
        { id: 23, label: 'Connection Status', key: 'connectionStatus' },
        { id: 24, label: 'Is Vip', key: 'isVip' },
        { id: 25, label: 'Site Status', key: 'isActive' },
        { id: 26, label: 'Action', key: 'action' },
        { id: 27, label: 'CupHolder', key: 'cupHolder' },
        { id: 28, label: 'TubeShield', key: 'tubeShield' },
        { id: 29, label: 'Led Rings', key: 'ledRings' },
        { id: 30, label: 'Last Updated By', key: 'LastUpdatedBy' },
        { id: 31, label: 'Sanitizer Level', key: 'sanitizerLevel' },
      ]
    };
  }

  async componentWillMount() { }

  async componentDidMount() {
    // const storedSorting = localStorage.getItem('sorting');
    // if (storedSorting) {
    //   this.setState({ sorting: storedSorting });
    // }
    var _ = this;
    $(document).ready(function () {
      $("body").off("click", ".editBtn").on("click", ".editBtn", function () {
        const record = $(this).attr("data-recordId");
        _.setState({
          machineEditModal: true,
          currentMachineId: record
        })
      });
      $("body").off("click", ".qrCodeBtn").on("click", ".qrCodeBtn", function () {
        const machineName = $(this).attr("data-machineName");
        const serialNumber = $(this).attr("data-serialNumber");

        _.setState({
          barCodeModal: true,
          machineName,
          serialNumber
        })
      });

      $("body").off("click", ".locationBtn").on("click", ".locationBtn", function () {
        const record = $(this).attr("data-recordId");
        _.setState({
          assignLocationModalOpen: true,
          currentMachineId: record
        })
      });
      $("body").off("click", ".changeLocationBtn").on("click", ".changeLocationBtn", function () {
        const record = $(this).attr("data-recordId");
        _.setState({
          changeLocationModal: true,
          currentMachineId: record
        })
      });
      $("body").off("click", ".viewStatusBtn").on("click", ".viewStatusBtn", function () {
        const record = $(this).attr("data-recordId");
        _.setState({
          viewStatusModelOpen: true,
          currentMachineId: record,
        });
      });
    });

    $("body").off("change", ".togBtn").on("change", ".togBtn", function () {
      const newStatus = $(this).is(":checked");
      const record = $(this).attr("data-recordId");
      _.machineStatus(record, newStatus);
      return false;
    });

    const savedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_FILTER_KEY) || "{}");
    const savedPage = parseInt(localStorage.getItem(LOCAL_STORAGE_PAGINATION_KEY) || "0", 10);

    if (Object.keys(savedFilters).length > 0) {
      this.setState({ ...savedFilters, page: savedPage }, async () => {
        await this.getFilterRecords();
        this.renderDataTable([]);
      });
    } else {
      await this.getFilterRecords();
      this.renderDataTable([]);
    }
  }

  async componentDidUpdate() {
    await this.handleMachineFilterSet()
   }
  getFilter = () => {
    let filter: any = {};
    if (this.state.filterLocation.length > 0) {
      filter["location_id"] = { in: this.state.filterLocation };
    }
    if (this.state.filterCustomer.length > 0) {
      filter["customer_id"] = { in: this.state.filterCustomer };
    }
    if (this.state.filterManager.length > 0) {
      filter["deploying_person_id"] = { in: this.state.filterManager };
    }
    if (this.state.filterBoard.length > 0) {
      filter["board_id"] = { in: this.state.filterBoard };
    }
    if (this.state.filterMacAddress) {
      filter["mac_address"] = { like: "%" + this.state.filterMacAddress + "%" };  
    }
    if (this.state.filterCupHolder.length > 0) {
      filter["cup_holder_id"] = { in: this.state.filterCupHolder };
    }
    if (this.state.filterTubeShield.length > 0) {
      filter["tube_shield_id"] = { in: this.state.filterTubeShield };
    }
    if (this.state.filterLedRings.length > 0) {
      filter["led_rings_id"] = { in: this.state.filterLedRings };
    }
    if (this.state.filterBlender.length > 0) {
      filter["blender_id"] = { in: this.state.filterBlender };
    }
    if (this.state.filterMechanicalHardwareVersion) {
      filter["hardware_version"] = { eq: this.state.filterMechanicalHardwareVersion };
    }
    // {
    //   value: 'only',
    //   label: 'Only Shorter tubedoor',
    // },
    // {
    //   value: 'exclude',
    //   label: 'Without Shorter tubedoor',
    // },
    // {
    //   value: 'all',
    //   label: 'With Shorter tubedoor',
    // }

    if (this.state.filterStatus === "true") {
      filter["is_active"] = { eq: true };
    } else if (this.state.filterStatus === "false") {
      filter["is_active"] = { eq: false };
    }
    if (this.state.filterStatus === "all") {
      delete filter["is_active"]
    }
    if (this.state.filterIsPolyfuses === "true") {
      filter["is_polyfuses"] = { eq: true };
    } else if (this.state.filterIsPolyfuses === "false") {
      filter["is_polyfuses"] = { eq: false };
    }
    if (this.state.filterIsPolyfuses === "all") {
      delete filter["is_polyfuses"]
    }
    if (this.state.filterName) {
      filter["name"] = { like: "%" + this.state.filterName + "%" };
    }
    if (this.state.filterSerialNumber) {
      filter["serial_number"] = { like: "%" + this.state.filterSerialNumber + "%" }
    }
    if (this.state.filterMachineStatus.length > 0) {
      filter["machine_status_id"] = { in: this.state.filterMachineStatus };
    }

    if (this.state.applyDateFilterOn !== "") {

      let dateFilterAppliedOnLabel = "";
      switch (this.state.applyDateFilterOn) {
        case 'createdAt':
          dateFilterAppliedOnLabel = 'created_at';
          break;
        case 'deploymentDate':
          dateFilterAppliedOnLabel = 'deployment_date';
          break;
        case 'retiredAt':
          dateFilterAppliedOnLabel = 'retired_at';
          break;
        case 'lastBladeReplaceAt':
          dateFilterAppliedOnLabel = 'last_blade_replace_at';
          break;
        case 'lastFilterReplacedAt':
          dateFilterAppliedOnLabel = 'last_filter_replaced_at';
          break;
        case 'lastSanitizerReplacedAt':
          dateFilterAppliedOnLabel = 'last_sanitizer_replaced_at';
          break;
      }

      if (this.state.filterFromDate !== "" || this.state.filterToDate !== "") {
        filter[dateFilterAppliedOnLabel] = {};
      }
      if (this.state.filterFromDate !== "" && this.state.filterToDate === "") {
        filter[dateFilterAppliedOnLabel]["gt"] = new Date(
          this.state.filterFromDate
        ).toISOString();
      } else if (
        this.state.filterFromDate === "" &&
        this.state.filterToDate !== ""
      ) {
        filter[dateFilterAppliedOnLabel]["lt"] = new Date(
          this.state.filterToDate
        ).toISOString();
      } else if (
        this.state.filterFromDate !== "" &&
        this.state.filterToDate !== ""
      ) {
        filter[dateFilterAppliedOnLabel]["between"] = [
          new Date(this.state.filterFromDate).toISOString(),
          new Date(this.state.filterToDate).toISOString(),
        ];
      }
    }
    return filter
  }
  saveFiltersToLocalStorage = () => {
    const {
      filterFromDate,
      filterToDate,
      filterBoard,
      filterTubeShield,
      filterLedRings,
      filterManager,
      filterName,
      filterCupHolder,
      filterStatus,
      filterBlender,
      filterLocation,
      filterAddHouseClamps,
      filterPendingInstallatio,
      filterIsVip, 
      filterIsPolyfuses ,
      filterMacAddress,
      filterMarketSegement,
      filterMechanicalHardwareVersion,
      filterSerialNumber,
      filterRegionId,
      filterDeploymentManagerId,
      filterMachineStatus,
      filterLocationType,
      filterInStock,
      applyDateFilterOn,
      filterCustomer,
    } = this.state;

    const filters = {
      filterFromDate,
      filterToDate,
      filterBoard,
      filterTubeShield,
      filterLedRings,
      filterManager,
      filterName,
      filterCupHolder,
      filterStatus,
      filterBlender,
      filterLocation,
      filterAddHouseClamps,
      filterPendingInstallatio,
      filterIsVip, 
      filterIsPolyfuses ,
      filterMacAddress,
      filterMarketSegement,
      filterMechanicalHardwareVersion,
      filterSerialNumber,
      filterRegionId,
      filterDeploymentManagerId,
      filterMachineStatus,
      filterLocationType,
      filterInStock,
      applyDateFilterOn,
      filterCustomer,
    };

    localStorage.setItem(LOCAL_STORAGE_FILTER_KEY, JSON.stringify(filters));
  };

  // Save pagination to localStorage
  savePageToLocalStorage = (currentPage: number) => {
    localStorage.setItem(LOCAL_STORAGE_PAGINATION_KEY, currentPage.toString());
  };
  renderDataTable = async (rows: any) => {
    var _this = this;
    const getPermissions: any = localStorage.getItem("permissions");
    const permissions = getPermissions || [];

    const filter = this.getFilter();
    await this.getColumnData();
    let inStock: any = false;
    if (this.state.filterInStock) {
      inStock = true;
    }
    const selectedMarketSegmentIds = this.state.filterMarketSegement ? this.state.filterMarketSegement : null;
    const filterAddHouseClamps = this.state.filterAddHouseClamps;
    const filterRegionId = this.state.filterRegionId ? this.state.filterRegionId : null;
    const filterIsVip = this.state.filterIsVip;
    const filterDeploymentManagerId = this.state.filterDeploymentManagerId ? this.state.filterDeploymentManagerId : null;
    const filterLocationType = this.state.filterLocationType ?this.state.filterLocationType:null;

    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    let authToken = "";
    if (lsValue) {
      const user = JSON.parse(lsValue);
      authToken = user.access_token;
    }
    $(document).ready(function () {
      $("#machineTable").DataTable().destroy();

      // eslint-disable-next-line
      const table = $("#machineTable").DataTable({
        pagingType: "full_numbers",
        serverSide: true,
        pageLength: 50,
        paging: true,
        searching: false,
        stateSave: true,
        data: rows,
        "ajax": {
          "url": process.env.REACT_APP_API_URL,
          "type": "POST",
          "contentType": "application/json",
          "beforeSend": function (xhr) {
            xhr.setRequestHeader('Authorization',
              "Bearer " + authToken);
          },
          "data": function (d: any) {
            var gql = ` query getMachines(
            $where: MachinesResolver_GetMachines_FilterInputType,
            $inStock:Boolean!,
            $paginate:PaginatorArgs,
            $extraFilter: MahineExtraFilterInputs
                 ) {
                  getMachines (where: $where ,inStock:$inStock,paginate: $paginate, extraFilter:  $extraFilter) {
                    data {
                      id
                      uuid
                      serialNumber
                      macAddress
                      name
                      deploymentDate
                      locationId
                      deployingPersonId
                      softwareVersion
                      hardwareVersion
                      connectionStatus
                      createdById
                      createdAt
                      isPolyfuses
                      lastSanitizerReplacedAt
                      lastFilterReplacedAt
                      isActive
                      remark
                      lastHearbeatSyncAt
                      lastBladeReplaceAt
                      lastSanitizeTime
                      retiredAt
                      retiredById
                      isRetired
                      blenderId
                      boardId
                      machineStatus{
                        id
                        name
                      }
                      retiredBy {
                        id
                        firstName
                        lastName
                      }
                      updatedBy {
                        id
                        firstName
                        lastName
                      }
                      deployingPerson {
                        id
                        firstName
                        lastName
                      }
                      location {
                        id
                        servicePlan{
                          id
                          indicater
                        }
                        customer{
                          id
                          name
                          customerCompanyName
                          isVip
                        }
                        name
                        address
                        deploymentManager{
                            firstName
                        }
                      }
                    blender {
                      id
                      title
                    }
                    board {
                      id
                      title
                    }
                    tubeShield{
                      id
                      name
                    }
                    ledRings{
                      id
                      name
                    }
                    cupHolder {
                      id
                      title
                    }
                      sanitizerLevel
                    }
                    totalPages
                    total
                    perPage
                    page
                  }

          }`;

            const currentPage = (d?.start) ? (d.start / d.length) + 1 : 1;
            // _this.setState({
            //   page: currentPage
            // })
            // _this.savePageToLocalStorage(currentPage); 
            const length = d?.length > 0 ? d.length : 50;
            // const sorting = d?.order?.[0]?.dir?.toUpperCase() || "ASC";
            // _this.setState({ sorting });
            var query = {
              "operationName": null,
              "query": gql,
              "variables": {
                "where": filter,
                inStock: inStock,
                paginate: {

                  "page": currentPage,
                  "per_page": length

                },
                extraFilter: {
                  marketSegmentId: selectedMarketSegmentIds,
                  addHouseClamps: filterAddHouseClamps,
                  regionId: filterRegionId,
                  deploymentManagerId: filterDeploymentManagerId,
                  is_vip: filterIsVip,
                  locatonTypeId:filterLocationType,
                }
              }
            };

            return JSON.stringify(query);
          },


          "dataSrc": function (json) {
            json.recordsTotal = json.data.getMachines.total;
            json.recordsFiltered = json.data.getMachines.total;

            const rows: any[] = [];
            const records = json.data.getMachines.data;
            // const currentPage = json.data.getMachines.page;
            // const recordsPerPage = json.data.getMachines.perPage;

            // const sorting = _this.state.sorting;

            // const sortedRecords = records.sort((a: any, b: any) => {
            //   const dateA = new Date(a.createdAt).getTime();
            //   const dateB = new Date(b.createdAt).getTime();
            //   return sorting === "ASC" ? dateA - dateB : dateB - dateA;
            // });

            // let counter: number;
            // if (sorting === "ASC") {
            //   counter = (currentPage - 1) * recordsPerPage + 1;
            // } else {
            //   counter = json.recordsTotal - (currentPage - 1) * recordsPerPage;
            // }

            // const recordsWithCounters = sortedRecords.map((record: any, index: number) => {
            //   const recordCounter = sorting === "ASC" ? counter + index : counter - index;
            //   return { ...record, counter: recordCounter };
            // });
        
            // _this.setState({ rows: recordsWithCounters });

            for (const record of records) {
              let deploymentDate = "";
              if (record.deploymentDate) {
                deploymentDate = Moment.unix(record.deploymentDate / 1000)
                  .format("YYYY-MM-DD");
              }
              let createdAt = "";
              if (record.createdAt) {
                createdAt = Moment.utc(record.createdAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss");
              }
              let retiredAt = ""
              if (record.retiredAt) {
                retiredAt = Moment.utc(record.retiredAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss");
              }
              let lastHearbeatSyncAt = ""
              if (record.lastHearbeatSyncAt) {
                lastHearbeatSyncAt = Moment.utc(record.lastHearbeatSyncAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss");
              }
              let lastSanitizeTime = ""
              if (record.lastSanitizeTime) {
                lastSanitizeTime = Moment.utc(record.lastSanitizeTime)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss");
              }
              const tempRecord = {
                id: record.uuid,
                customerName: record.location?.customer?.name ?? '',
                is_vip: record.location?.customer?.isVip === true ? 'Yes' : 'No',
                macAddress: record.macAddress ?? "",
                customerCompanyName: record.location?.customer?.customerCompanyName ?? "",
                locationId: record.locationId ?? "",
                locationName: record.location?.name ?? "",
                locationAddress: record.location?.address ?? "",
                serialNumber: record.serialNumber,
                machineName: record.name,
                lastSanitizerReplacedAt: record.lastSanitizerReplacedAt ? Moment.utc(record.lastSanitizerReplacedAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss") : "",
                lastFilterReplacedAt: record.lastFilterReplacedAt ? Moment.utc(record.lastFilterReplacedAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss") : "",
                lastHearbeatSyncAt,
                lastBladeReplaceAt: record.lastBladeReplaceAt ? Moment.utc(record.lastBladeReplaceAt)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss") : "",
                lastSanitizeTime,
                deploymentDate: deploymentDate,
                deploymentManager: record.location?.deploymentManager?.firstName ?? "",
                deployedBy: record.deployingPerson?.firstName ?? "",
                remark: record.remark ?? "",
                createdAt,
                retiredAt,
                retiredBy: record?.retiredBy?.firstName ?? "",
                LastUpdatedBy: record?.updatedBy?.firstName ?? "",
                blender: record?.blender?.title ?? "",
                machineStatus: record?.machineStatus?.name ?? "",
                board: record?.board?.title ?? "",
                tubeShield: record?.tubeShield?.name ?? "",
                ledRings: record?.ledRings?.name ?? "",
                cupHolder:record?.cupHolder?.title ?? "",
                isActive: record.isActive,
                connectionStatus: _.capitalize(_.lowerCase(record.connectionStatus)),
                softwareVersion: record.softwareVersion ?? 0,
                hardwareVersion: record.hardwareVersion ?? 0,
                isPolyfuses: record.isPolyfuses,
                sanitizerLevel: record.sanitizerLevel,
                indicater:record.location?.servicePlan?.indicater,
                recordId: record.id,
                record: record,
              };
              rows.push(tempRecord);
            }
            return rows;
          },
        },
        "initComplete": function (settings, json) {
          //table.page(Number(_this.state.page)).draw(false);

        },
        columns: [
          {
            name: "index",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let json = JSON.stringify(row);
              let jsonString = json.replaceAll("'","");
              let returnsData =
                '<div data-bs-toggle="tooltip" title="Click here to view machine"><a class="clickable_entry" data-value=\'' + jsonString + '\' href="/machines/list/history/' +
                 row.recordId +
                '"> ' +
                row.id +
                "</div></a>";
              return returnsData;
            },
          },
          {
            name: "locationName",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              const iconHTML = ReactDOMServer.renderToString(
                <IconPickerItem icon={row.indicater} size={20} color="#ffc700" />
              );
              
              let returnsData = "";
              if (row.is_vip === 'Yes') {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to view location">' +
                  '<a href="/locations/list/history/' + row.locationId + '" class="d-flex align-items-center">' +
                  '<i class="fa fa-crown text-warning me-1"></i>' +
                  iconHTML +
                  '<span class="ms-1">' + row.locationName + '</span>' +
                  iconHTML +
                  '</a></div>';
              } else {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to view location">' +
                  '<a href="/locations/list/history/' + row.locationId + '" class="d-flex align-items-center">' +
                  iconHTML +
                  '<span class="ms-1">' + row.locationName + '</span>' +
                  iconHTML +
                  '</a></div>';
              }
              return returnsData;
            },
          },
          {
            name: "macAddress",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let returnsData =
                '<div data-bs-toggle="tooltip" title="Click here to view machine"><a  href="/machines/list/history/' +
                row.recordId +
                '"> ' +
                row.macAddress +
                "</div></a>";
              return returnsData;
            },
          },
          {
            name: "serialNumber",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let returnsData =
                '<div data-bs-toggle="tooltip" title="Click here to view machine"><a href="/machines/list/history/' +
                row.recordId +
                '"> ' +
                row.serialNumber +
                "</div></a>";
              return returnsData;
            },
          },

          {
            name: "machineName",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let returnsData =
                '<div data-bs-toggle="tooltip" title="Click here to view machine"><a  href="/machines/list/history/' +
                row.recordId +
                '"> ' +
                row.machineName +
                "</div></a>";
              return returnsData;
            },
          },
          {
            name: "deploymentDate",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.deploymentDate;
            },
          },
          {
            name: "deployedBy",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.deployedBy;
            },
          },
          {
            name: "machineStatus",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.machineStatus;
            },
          },
          {
            name: "remark",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.remark;
            },
          },
          {
            name: "softwareVersion",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.softwareVersion;
            },
          },
          {
            name: "hardwareVersion",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.hardwareVersion;
            },
          },
          {
            name: "isPolyfuses",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row?.isPolyfuses ? 'Yes' : 'No';
            },
          },
          {
            name: "createdAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.createdAt;
            },
          },
          {
            name: "LastUpdatedBy",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('LastUpdatedBy'),
            render: function (data, type, row) {
              return row.LastUpdatedBy;
            },
          },
          {
            name: "retiredAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.retiredAt;
            },
          },
          {
            name: "retiredBy",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.retiredBy;
            },
          },
          {
            name: "blender",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.blender;
            },
          },
          {
            name: "board",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.board;
            },
          },
          {
            name: "cupHolder",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.cupHolder;
            },
          },
          {
            name: "tubeShield",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.tubeShield;
            },
          },
          {
            name: "ledRings",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.ledRings;
            },
          },
          {
            name: "lastSanitizeTime",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.lastSanitizeTime;
            },
          },
          {
            name: "lastHearbeatSyncAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.lastHearbeatSyncAt;
            },
          },
          {
            name: "lastSanitizerReplacedAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.lastSanitizerReplacedAt;
            },
          },
          {
            name: "lastBladeReplaceAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.lastBladeReplaceAt;
            },
          },
          {
            name: "lastFilterReplacedAt",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('lastFilterReplacedAt'),
            render: function (data, type, row) {
              return row.lastFilterReplacedAt;
            },
          },
          {
            name: "connectionStatus",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              return row.connectionStatus;
            },
          },
          {
            name: "isVip",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('isVip'),
            render: function (data, type, row) {
              return row.is_vip;
            },
          },
          {
            name: "sanitizerLevel",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('sanitizerLevel'),
            render: function (data, type, row) {
              return row.sanitizerLevel;
            },
          },
          {
            name: "isActive",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let returnData = "";
              if (permissions?.includes("update-machine") === true) {
                let isChecked =
                  row.isActive === true
                    ? 'checked="checked"'
                    : row.isActive === false;
                returnData +=
                  '<label class="status-switch"><input type="checkbox" ' +
                  isChecked +
                  "  data-recordId='" +
                  row.recordId +
                  '\' class="togBtn"><div class="status-slider round"></div></label>';
              } else {
                if (row.isActive === true) {
                  returnData += '<div class="text-dark"> Active</div>';
                } else {
                  returnData += '<div class="text-dark"> Inactive</div>';
                }
              }
              return returnData;
            },
          },
          {
            name: "action",
            visible: _this.state.selectedColumns || _this.state.selectedColumns.includes('index'),
            render: function (data, type, row) {
              let returnsData =  '<div class="custom-action-wrapper">';
              if (permissions?.includes("update-machine") === true) {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to edit machine"><button class="btn btn-secondary btn editBtn p-2 px-4 m-1" data-recordId=\'' +
                  row.recordId +
                  "'><i class='fa fa-pencil' style='font-size:1rem;'></i></button></div>";
              }
              returnsData +=
                '<div data-bs-toggle="tooltip" title="Click here to view machine"><a class="btn btn-primary btn p-2 px-4 m-1" href="/machines/list/history/' +
                row.recordId +
                '"><i class="fa fa-eye"></i></a></div>';
                returnsData +=
                '<div data-bs-toggle="tooltip" title="Click here to view barcode"><button class="btn btn-secondary btn qrCodeBtn p-2 px-4 m-1" ' +
                'data-machineName="' + row.machineName + '" ' + 'data-serialNumber="' + row.serialNumber + '">' +'<i class="fa fa-barcode"></i>' +
                '</button>' + '</div>';
              if (row.locationId === "") {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to assign location"><button class="btn btn-secondary btn locationBtn p-2 px-4 m-1" data-recordId=\'' +
                  row.recordId +
                  "'><i class='fa-solid fa-location-dot'></i></button></div>";
              }
              if (row.locationId !== "") {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to change location"><button class="btn btn-secondary btn changeLocationBtn p-2 px-4 m-1" data-recordId=\'' +
                  row.recordId +
                  "'><i class='fa fa-exchange' ></i></i></button></div>";
              }
              if (row.isActive !== "") {
                returnsData +=
                  '<div data-bs-toggle="tooltip" title="Click here to view status"><button class="btn btn-secondary btn viewStatusBtn p-2 px-4 m-1" data-recordId=\'' +
                  row.recordId +
                  "'><i class='fa fa-display' ></i></i></button></div>";
              }
              return returnsData;
            },
          },
        ],
        processing: true,
        dom: '<"row mb-2"<"col-md-6 text-left"i><"col-md-6 text-right"p>>rt<"row mb-2"<"col-md-6 text-left"i><"col-md-6 text-right"p>>',
        order: [[0, "desc"]],
        lengthMenu: [
          [10, 20, 30, 50, -1],
          [10, 20, 30, 50, "All"],
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data, type, row, meta) {
              return type === "export" ? meta.row + 1 : data;
            },
          },
        ],
        createdRow: function (row, data, rowIndex) {
          var title: any = [];
          $("#machineTable thead tr th").each(function () {
            title.push($(this).text());
          });
          $.each($("td", row), function (colIndex) {
            $(this).attr("data-title", title[colIndex]);
          });
        },
      });
      table.on('page', function () {
        const currentPage = table.page.info();

        _this.setState({
          page: currentPage.page
        })

      });
      $(document)[0].oncontextmenu = function () { return false; }

      $('#machineTable tbody').mousedown(function (e) {
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || /Mobi|Android/i.test(navigator.userAgent)) {
          return true; // Do nothing if it's a touch screen device
        }
        if (e.buttons === 1) return true;
        
        e.preventDefault();
        var top = e.clientY;
        var left = e.clientX;
        const recordString = $(e.target).parents('tr').find('a.clickable_entry').attr('data-value');
        let record;
        if (recordString) {
          record = JSON.parse(recordString)
        }
        if (record) {
          if (record.record.locationId !== null) {
            $('#changelocation_record_link').show().attr('data-recordId', record.recordId)
          }
          else {
            $('#changelocation_record_link').hide().attr(
              'data-recordId', ''
            )
          }
          if (record.record.locationId == null) {
            $('#assignlocation_record_link').show().attr('data-recordId', record.recordId)
          }
          else {
            $('#assignlocation_record_link').hide().attr(
              'data-recordId', ''
            )
          }
          $('#view_record_link').attr('href', `/machines/list/history/${record.recordId}`)
          $("#viewStatus_record_link").attr("data-recordId", record.recordId);
          $('#edit_record_link').attr('data-recordId', record.recordId)
          $('#createTicket_record_link').attr('href', `/tickets/create?machine_id=${record.recordId}&label=${record?.record?.location?.name ?? ""} (${record?.record?.serialNumber ?? ""})`)
          $('#context-menu').parent('.dropdown-menu').addClass('d-block')
          $("#context-menu").css({
            top: top,
            left: left
          }).show();
        }
        return false;
      })
      $('html').click(function () {
        $("#context-menu").hide();
        $('#context-menu').parent('.dropdown-menu').removeClass('d-block')
      })
      _this.displaySelectedColumns(table);
    });
    $(".dt-buttons").remove();
  };

  async getFilterRecords() {
    const {ledRings, machines,locations,users,regions,hardwareVersions,blenders,boards,marketSegment,cupHolders,locationTypes,machineStatus,tubeShields,customers} = this.props;

    this.setState({
      blenderDB: blenders,
      boardDB: boards,
      cupHolderDB: cupHolders,
      locationDB: locations,
      locationRegionDB: regions,
      managerDB: users,
      machinesDB: machines,
      marketSegmentDB: marketSegment,
      machineStatusDB: machineStatus,
      locationTypeDB: locationTypes,
      tubeShieldDB: tubeShields,
      ledRingsDB: ledRings,
      customerDB: customers,
      hardwareVersionsList: [...hardwareVersions.slice().sort((a:any, b:any) => parseFloat(a) - parseFloat(b)), 'missing']
    });
  }


  handleDownloadExcel = async () => {
    this.setState({
      downloadLoading: true
    })
    const filter = this.getFilter();
    let inStock: any = false;
    if (this.state.filterInStock) {
      inStock = true;
    }

    const selectedMarketSegmentIds = this.state.filterMarketSegement ? this.state.filterMarketSegement : null;
    const filterAddHouseClamps = this.state.filterAddHouseClamps;
    const filterRegionId = this.state.filterRegionId ? this.state.filterRegionId : null;
    const filterIsVip = this.state.filterIsVip;
    const filterDeploymentManagerId = this.state.filterDeploymentManagerId ? this.state.filterDeploymentManagerId : null;
    const filterLocationType = this.state.filterLocationType ? this.state.filterLocationType : null;

    const extraFilter = {
      marketSegmentId: selectedMarketSegmentIds,
      addHouseClamps: filterAddHouseClamps,
      regionId: filterRegionId,
      deploymentManagerId: filterDeploymentManagerId,
      is_vip: filterIsVip,
      locatonTypeId: filterLocationType,
    }
    const result: any = await getMachines(filter, inStock, undefined, extraFilter); 
    const allKeys = this.state.columnData.map((col: any) => col.key);
    const selectedColumns = this.state.selectedColumns?.length > 0 ? this.state.selectedColumns : allKeys;
    const excelRecords = [];
    for (const record of result.data) {
      const tempRecord: any = {};
  
      if (selectedColumns.includes('index')) tempRecord.id = record.uuid;
      if (selectedColumns.includes('locationName')) tempRecord['Location name'] = record.location?.name ?? '';
      if (selectedColumns.includes('serialNumber')) tempRecord['Serial number'] = record.serialNumber;
      if (selectedColumns.includes('macAddress')) tempRecord['Mac address'] = record.macAddress;
      if (selectedColumns.includes('machineName')) tempRecord['Machine name'] = record.name;
      if (selectedColumns.includes('lastHearbeatSyncAt')) tempRecord['Last heartbeat Sync at'] = record.lastHearbeatSyncAt
        ? Moment.utc(record.lastHearbeatSyncAt).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('lastSanitizerReplacedAt')) tempRecord['Last sanitizer replaced at'] = record.lastSanitizerReplacedAt
        ? Moment.utc(record.lastSanitizerReplacedAt).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('lastBladeReplaceAt')) tempRecord['Last blade replaced at'] = record.lastBladeReplaceAt
        ? Moment.utc(record.lastBladeReplaceAt).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('lastSanitizeTime')) tempRecord['Last sanitize at'] = record.lastSanitizeTime
        ? Moment.utc(record.lastSanitizeTime).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('lastFilterReplacedAt')) tempRecord['Last Filter Replaced At'] = record.lastFilterReplacedAt
        ? Moment.utc(record.lastFilterReplacedAt).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('deploymentDate')) tempRecord['Deployed at'] = record.deploymentDate
        ? Moment.unix(record.deploymentDate / 1000).local().format("YYYY-MM-DD")
        : '';
      if (selectedColumns.includes('deployedBy')) tempRecord['Deployed by'] = record.deployingPerson?.firstName ?? '';
      if (selectedColumns.includes('machineStatus')) tempRecord['Machine Status'] = _.capitalize(_.lowerCase(record?.machineStatus?.name ?? ''));
      if (selectedColumns.includes('remark')) tempRecord['Remark'] = record.remark ?? '';
      if (selectedColumns.includes('blender')) tempRecord['Blender'] = record?.blender?.title ?? '';
      if (selectedColumns.includes('board')) tempRecord['Board'] = record?.board?.title ?? '';
      if (selectedColumns.includes('cupHolder')) tempRecord['Cup holder'] = record?.cupHolder?.title ?? '';
      if (selectedColumns.includes('tubeShield')) tempRecord['Tube Shield'] = record?.tubeShield?.name ?? '';
      if (selectedColumns.includes('ledRings')) tempRecord['Led Rings'] = record?.ledRings?.name ?? '';
      if (selectedColumns.includes('isVip')) tempRecord['Is Vip'] = record.location?.customer?.isVip === true ? 'Yes' : 'No';
      if (selectedColumns.includes('isActive')) tempRecord['Site Status'] = record.isActive === true ? 'Active' : 'In active';
      if (selectedColumns.includes('IS pilot?')) tempRecord['IS pilot?'] = record.isPilot === true ? 'Yes' : 'No';
      if (selectedColumns.includes('Trial end date')) tempRecord['Trial end date'] = record.isPilot === true ? record.trialEndDate : '';
      if (selectedColumns.includes('connectionStatus')) tempRecord['Connection status'] = _.capitalize(_.lowerCase(record.connectionStatus));
      if (selectedColumns.includes('softwareVersion')) tempRecord['Software version'] = record.softwareVersion ?? 0;
      if (selectedColumns.includes('hardwareVersion')) tempRecord['Mechanical hardware version'] = record.hardwareVersion ?? 0;
      if (selectedColumns.includes('isPolyfuses')) tempRecord['Has polyfuses?'] = record?.isPolyfuses ? 'Yes' : 'No';
      if (selectedColumns.includes('createdAt')) tempRecord['Created at'] = Moment.utc(record.createdAt).local().format("YYYY-MM-DD HH:mm:ss");
      if (selectedColumns.includes('retiredAt')) tempRecord['Retired at'] = record.retiredAt
        ? Moment.utc(record.retiredAt).local().format("YYYY-MM-DD HH:mm:ss")
        : '';
      if (selectedColumns.includes('retiredBy')) tempRecord['Retired By'] = record?.retiredBy?.firstName ?? '';
      if (selectedColumns.includes('LastUpdatedBy')) tempRecord['Last Updated By'] = record?.updatedBy?.firstName ?? '';
      if (selectedColumns.includes('sanitizerLevel')) tempRecord['Sanitizer Level'] = record?.sanitizerLevel ?? '';

  

      if (record?.metas?.length > 0) {
        for (let meta of record.metas) {
          const keyName = _.capitalize(_.toLower(meta.metaKey.replaceAll('_', ' ').trim()));
          if (selectedColumns.includes(keyName)) {
            tempRecord[keyName] = meta.metaValue;
          }
        }
      }
      excelRecords.push(tempRecord);
    }
    this.setState({
      downloadLoading: false
    })
    DownloadExcel(excelRecords, "SHEET_NAME", "Machines_list");
  }

  machineStatus = async (recordId: any, newStatus: boolean) => {
    try {
      await updateMachineIsActiveStatus(recordId, newStatus);
    } catch (e: any) {
      console.log(e);
    }
  };


  handleCloseMachine = () => {
    this.setState({
      machineEditModal: false,
      currentMachineId: ""

    });
  };
  handleCloseChangeLocation = () => {
    this.setState({
      changeLocationModal: false,
      currentMachineId: ""
    })
  }
  handleCloseAssignLocation = () => {
    this.setState({
      assignLocationModalOpen: false,
      currentMachineId: ""
    })
  }
  handleCloseViewStatus = () => {
    this.setState({
      viewStatusModelOpen: false,
      currentMachineId: "",
    });
  };

  handleCloseBarCode = () => {
    this.setState({
      barCodeModal: false,
      machineName:"",
      serialNumber:""
    })
  }
  refreshTable = async () => {
    await this.getFilterRecords();
    this.renderDataTable([]);
  }

  searchData = async () => {
    localStorage.removeItem('DataTables_machineTable_/machines/list')

    this.setState({
      addLoading: true,
    });
    this.saveFiltersToLocalStorage();
    this.renderDataTable([]);
    this.setState({
      addLoading: false,
    });
    return false;
  };

  removeSearch = async () => {
    this.setState({
      filterLoading: true,
    });
    localStorage.removeItem(LOCAL_STORAGE_FILTER_KEY);
    localStorage.removeItem(LOCAL_STORAGE_PAGINATION_KEY);
    if (this.state.resetStatus.current) {
      this.state.resetStatus.current.setValue({
        label: "Active",
        value: "true",
      });
    }
    this.state.resetAddHouseClamps.current.setValue("");
    this.state.resetMechanicalHardwareVersion.current.setValue("");
    this.state.resetIsVip.current.setValue("");
    this.state.resetIsPolyfuses.current.setValue("");
    // eslint-disable-next-line
    this.state.resetFrom.current.state.inputValue = "";
    // eslint-disable-next-line
    this.state.resetTo.current.state.inputValue = "";
    this.setState({
      filterToDate: "",
      filterFromDate: "",
      filterStatus: "true",
      filterName: "",
      filterMacAddress:"",
      filterSerialNumber: "",
      filterMechanicalHardwareVersion: "",
      filterLocation: "",
      filterManager: "",
      filterBoard: "",
      filterCupHolder:"",
      filterBlender: "",
      filterTubeShield:"",
      filterLedRings:"",
      filterInStock: "",
      filterMachineStatus:"",
      filterIsVip: "",
      filterLocationType:"",
      filterIsPolyfuses: "",
      filterAddHouseClamps: "",
      filterRegionId: [],
      filterDeploymentManagerId: [],
      filterMarketSegement: [],
      filterReplace: null,
      locationTypeSelected:null,
      inStock: false,
      locationSelected: null,
      managerSelected: null,
      blenderSelected: null,
      boardSelected: null,
      tubeShiledSelected:null,
      cupHolderSelected:null,
      ledRingsSelected: null,
      locationRegionSelected: null,
      deploymentManagerSelected: null,
      marketSegmentIdSelected: [],
      machineStatusSelected: null,
    });
    await this.getFilterRecords();
    this.renderDataTable([]);
    this.setState({
      filterLoading: false,
    });
    return false;
  };
  // async getColumnData() {
  getColumnData = async () => {
    var _ = this;
    const data = await getModuleDataDisplaySettingByKey(this.state.moduleKeyName);
    if (data) {
      _.setState({ selectedColumns: data.metaValue })
      return data.metaValue;
    }
    return [];
  }

  displaySelectedColumns = async (table: any) => {
    var _this = this;
    if (_this.state.selectedColumns.length > 0) {
      table.settings().init().columns?.map(function (val: any, key: any) {
        if (!_this.state.selectedColumns.includes(val.name)) {
          table.column(key).visible(false);
        }else {
          table.column(key).visible(true); // Ensure selected columns are made visible
        }
        return false;
      });
    }
    $('#machineTable').show();
    return false;
  };

  handleColumnDataSelect = async (e: any) => {
    const selCol = (e.target.checked)
      ? [...this.state.selectedColumns, e.target.value]
      : this.state.selectedColumns.filter((item: string) => item !== e.target.value);
    this.setState({ selectedColumns: selCol });
  };

  handleColumnDataSubmit = async (e: any) => {
    const selectedColumns = this.state.selectedColumns;
    await updateModuleDataDisplaySettingByKey(this.state.moduleKeyName, selectedColumns);
    this.refreshTable();
  };
  handleSelectAll = () => {
    const { selectedColumns, columnData } = this.state;
    const allKeys = columnData.map((col: any) => col.key);
    if (selectedColumns.length === columnData.length) {
        this.setState({ selectedColumns: [] });
    } else {
        this.setState({ selectedColumns: allKeys });
    }
};
  handleMachineFilterSet = async () => {
      if (this.state.filterDeploymentManagerId) {
        const selectManager = this.state.managerDB.filter((data: any) => this.state.filterDeploymentManagerId.includes(data.id))
       
        const finalSelectedManagerResponse = selectManager.map((x: any) => {
          return {
            value: x.id,
            label: x.firstName
          }
        })
         if (JSON.stringify(finalSelectedManagerResponse) !== JSON.stringify(this.state.deploymentManagerSelected)) {
          this.setState({
            deploymentManagerSelected: finalSelectedManagerResponse,
          });
        }
      }

      if (this.state.filterCustomer) {
        const selectCustomer = this.state.customerDB.filter((data: any) => this.state.filterCustomer.includes(data.id))
        const finalSelectedCustomerResponse = selectCustomer.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedCustomerResponse ) !== JSON.stringify(this.state.customerSelected)) {
          this.setState({
            customerSelected: finalSelectedCustomerResponse,
          });
        }
      }

      if (this.state.filterLocation) {
        const selectLocation = this.state.locationDB.filter((data: any) => this.state.filterLocation.includes(data.id))
        const finalSelectedLocationResponse = selectLocation.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedLocationResponse) !== JSON.stringify(this.state.locationSelected)) {
          this.setState({
            locationSelected: finalSelectedLocationResponse,
          });
        }
      }
      if (this.state.filterRegionId) {
        const selectRegionId = this.state.locationRegionDB.filter((data: any) => this.state.filterRegionId.includes(data.id))
        const finalSelectedRegionIdResponse = selectRegionId.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedRegionIdResponse) !== JSON.stringify(this.state.locationRegionSelected)) {
          this.setState({
            locationRegionSelected: finalSelectedRegionIdResponse,
          });
        }
      } 
      if (this.state.filterMarketSegement) {
        const selectMarketSegment = this.state.marketSegmentDB.filter((data: any) => this.state.filterMarketSegement.includes(data.id))
        const finalSelectedMarketSegmentResponse = selectMarketSegment.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedMarketSegmentResponse) !== JSON.stringify(this.state.marketSegmentIdSelected)) {
          this.setState({
            marketSegmentIdSelected: finalSelectedMarketSegmentResponse,
          });
        }
      }
      if (this.state.filterBlender) {
        const selectBlender = this.state.blenderDB.filter((data: any) => this.state.filterBlender.includes(data.id))
        const finalSelectedBlenderResponse = selectBlender.map((x: any) => {
        
          return {
            value: x.id,
            label: x.title,
            description: x.description,
            mediaUrl: x.mediaUrl,
          }
        })
         if (JSON.stringify(finalSelectedBlenderResponse) !== JSON.stringify(this.state.blenderSelected)) {
          this.setState({
            blenderSelected: finalSelectedBlenderResponse,
          });
        }
      }
      if (this.state.filterBoard) {
        const selectBoard = this.state.boardDB.filter((data: any) => this.state.filterBoard.includes(data.id))
        const finalSelectedBoardResponse = selectBoard.map((x: any) => {
          
          return {
            value: x.id,
            label: x.title,
            description: x.description,
            mediaUrl: x.mediaUrl,
          }
        })
         if (JSON.stringify(finalSelectedBoardResponse) !== JSON.stringify(this.state.boardSelected)) {
          this.setState({
            boardSelected: finalSelectedBoardResponse,
          });
        }
      }
      if (this.state.filterCupHolder) {
        const selectCupHolder = this.state.cupHolderDB.filter((data: any) => this.state.filterCupHolder.includes(data.id))
        const finalSelectedCupHolderResponse = selectCupHolder.map((x: any) => {
          
          return {
            value: x.id,
            label: x.title,
            description: x.description,
            mediaUrl: x.mediaUrl,
          }
        })
         if (JSON.stringify(finalSelectedCupHolderResponse) !== JSON.stringify(this.state.cupHolderSelected)) {
          this.setState({
            cupHolderSelected: finalSelectedCupHolderResponse,
          });
        }
      }
      if (this.state.filterMechanicalHardwareVersion) {
        const selectMechanicalHardwareVersion = this.state.hardwareVersionsList.filter((data: any) => this.state.filterMechanicalHardwareVersion.includes(data.id))
        const finalSelectedMechanicalHardwareVersionResponse = selectMechanicalHardwareVersion.map((x: any) => {
          
          return {
            value: x.value,
            label: x.value
          }
        })
         if (JSON.stringify(finalSelectedMechanicalHardwareVersionResponse) !== JSON.stringify(this.state.hardwareVersionSelected)) {
          this.setState({
            hardwareVersionSelected: finalSelectedMechanicalHardwareVersionResponse,
          });
        }
      }
      if (this.state.filterMachineStatus) {
        const selectMachineStatus = this.state.machineStatusDB.filter((data: any) => this.state.filterMachineStatus.includes(data.id))
        const finalSelectedMachineStatusResponse = selectMachineStatus.map((x: any) => {
        
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedMachineStatusResponse) !== JSON.stringify(this.state.machineStatusSelected)) {
          this.setState({
            machineStatusSelected: finalSelectedMachineStatusResponse,
          });
        }
      }
      if (this.state.filterLocationType) {
        const selectLocationType = this.state.locationTypeDB.filter((data: any) => this.state.filterLocationType.includes(data.id))
        const finalSelectedLocationTypeResponse = selectLocationType.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name
          }
        })
         if (JSON.stringify(finalSelectedLocationTypeResponse) !== JSON.stringify(this.state.locationTypeSelected)) {
          this.setState({
            locationTypeSelected: finalSelectedLocationTypeResponse,
          });
        }
      }
      if (this.state.filterTubeShield) {
        const selectTubeShield = this.state.tubeShieldDB.filter((data: any) => this.state.filterTubeShield.includes(data.id))
        const finalSelectedTubeShieldResponse = selectTubeShield.map((x: any) => {
          
          return {
            value: x.id,
            label: x.name,
            mediaUrl: x.mediaUrl,
            description: x.description,
          }
        })
         if (JSON.stringify(finalSelectedTubeShieldResponse) !== JSON.stringify(this.state.tubeShiledSelected)) {
          this.setState({
            tubeShiledSelected: finalSelectedTubeShieldResponse,
          });
        }
    }
    if (this.state.filterLedRings) {
      const selectLedRings = this.state.ledRingsDB.filter((data: any) => this.state.filterLedRings.includes(data.id))
      const finalSelectedLedRingsResponse = selectLedRings.map((x: any) => {
        
        return {
          value: x.id,
          label: x.name,
          mediaUrl: x.mediaUrl,
          description: x.description,
        }
      })
       if (JSON.stringify(finalSelectedLedRingsResponse) !== JSON.stringify(this.state.ledRingsSelected)) {
        this.setState({
          ledRingsSelected: finalSelectedLedRingsResponse,
        });
      }
  }
  }

  render() {
    return (
      <>
        <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
            style={{ maxWidth: "100%" }}
          >
            <div className="page-title d-flex flex-column justify-content-center flex-wrap">
              <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
                Machines List
              </h1>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
              <button
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#machine-filter"
                aria-expanded="false"
                aria-controls="machine-filter"
                className="btn btn-bg-light collapsed fw-bold m-0 p-0 px-5 py-3 align-items-center card-title text-center">
                <KTSVG
                  path="/media/icons/duotune/general/gen031.svg"
                  className="svg-icon-4 me-1"
                />
                Filter
              </button>
                <Breadcrumb
                links={[
                  { label: "Home", href: "/dashboard", isActive: false },
                  { label: "Machines List", href: "", isActive: true },
                ]}
                />
            </div>
          </div>
        </div>
        <MachineFilter
          state={this.state}
          setState={this.setState.bind(this)}
          searchData={this.searchData}
          removeSearch={this.removeSearch}
        />
        <Columns
          columnData={this.state.columnData}
          selectedColumns={this.state.selectedColumns}
          handleColumnDataSelect={this.handleColumnDataSelect}
          handleColumnDataSubmit={this.handleColumnDataSubmit}
          handleSelectAll={this.handleSelectAll}
         />
        <div className="card mt-9" style={{ zIndex: 0 }}>
          <div className="card-body w-100 p-lg-7 p-md-7 p-5">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-2 col-lg-3 col-md-4 col-12">
                {/* <h3 className="btn btn-bg-light fw-bold m-0 mb-3 p-0 px-5 py-3 align-items-center card-title text-center">
                  <KTSVG
                    path="/media/icons/duotune/electronics/elc002.svg"
                    className="svg-icon-4 me-1"
                  />
                  Machines
                </h3> */}
                 <button
                  type="button"
                  className="btn btn-bg-light btn-active-color-primary fw-bold btn-block w-100 p-0 px-4 py-3 mb-3"
                  data-bs-toggle="modal"
                  data-bs-target="#columnsModal"
                >
                  Columns
                </button>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-4 col-12">
                <button
                  onClick={this.handleDownloadExcel}
                  className="btn btn-bg-light btn-active-color-primary fw-bold btn-block w-100 p-0 px-4 py-3 mb-3"
                >
                  {this.state.downloadLoading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please Wait..
                      <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                    </span>
                  )}
                  {!this.state.downloadLoading && (
                    <span className="indicator-label"> <KTSVG
                      path="/media/icons/duotune/files/fil021.svg"
                      className="svg-icon-4 me-2"
                    />
                      Export Excel</span>
                  )}

                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="table-responsive p-0 pb-2 fs-6" id="data-table">
                  <table
                    id="machineTable"
                    className="table align-items-center responsive-table display justify-content-center mb-0 w-100"
                  >
                    <thead>
                      <tr>
                        <th className="machineId text-capitalize font-weight-bolder opacity-7 ps-2">
                          Machine ID
                          <Tooltip anchorSelect=".machineId" className="tooltip-list " data-placement="top">
                          Internal software identifier- not serial number
                          </Tooltip>
                        </th>
                        <th className="locationName text-capitalize font-weight-bolder opacity-7 ps-2">
                          Location Name
                          <Tooltip anchorSelect=".locationName" className="tooltip-list " data-placement="top">
                          Enter the name of the location, followed by dash followed by  the city in which it is situated.
                          </Tooltip>
                        </th>
                        <th className="macAddress text-capitalize font-weight-bolder opacity-7 ps-2">
                          Mac address
                          <Tooltip anchorSelect=".macAddress" className="tooltip-list " data-placement="top">
                          The MAC address is located in the bottom field of the service menu
                          </Tooltip>
                        </th>
                        <th className="serialNumber text-capitalize font-weight-bolder opacity-7 ps-2">
                          Serial Number
                           <Tooltip anchorSelect=".serialNumber" className="tooltip-list " data-placement="top">
                           Find the serial number behind the screen, within the service door compartment.
                          </Tooltip>
                        </th>
                        <th className="machineName text-capitalize font-weight-bolder opacity-7 ps-2">
                          Machine Name
                           <Tooltip anchorSelect=".machineName" className="tooltip-list " data-placement="top">
                           Enter the name of the location, followed by dash followed by  the city in which it is situated.
                          </Tooltip>
                        </th>
                        <th className="deploymentDate text-capitalize font-weight-bolder opacity-7 ps-2">
                          Deployment Date
                           <Tooltip anchorSelect=".deploymentDate" className="tooltip-list " data-placement="top">
                           Date when the machine was installed
                          </Tooltip>
                        </th>
                        <th className="deployedBy text-capitalize font-weight-bolder opacity-7 ps-2">
                          Deployed By
                           <Tooltip anchorSelect=".deployedBy" className="tooltip-list " data-placement="top">
                           Specify the name of the individual from Smoodi who installed the machine. If the installation was done by a third-party company, select the company's name.
                          </Tooltip>
                        </th>
                        <th className="machineStatus text-capitalize font-weight-bolder opacity-7 ps-2">
                          Machine Status
                        </th>
                        <th className="remark text-capitalize font-weight-bolder opacity-7 ps-2">
                          Remark
                           <Tooltip anchorSelect=".remark" className="tooltip-list " data-placement="top">
                           Note pertaining to this machine.
                          </Tooltip>
                        </th>
                        <th className="softwareVersion text-capitalize font-weight-bolder opacity-7 ps-2">
                          Software Version
                           <Tooltip anchorSelect=".softwareVersion" className="tooltip-list " data-placement="top">
                           Displays the software version currently installed on the machine.
                          </Tooltip>
                        </th>
                        <th className="mechanicalHardwareVersion text-capitalize font-weight-bolder opacity-7 ps-2">
                          Mechanical Hardware Version
                           <Tooltip anchorSelect=".mechanicalHardwareVersion" className="tooltip-list " data-placement="top">
                           Displays the version of the machine as determined by its production date.
                          </Tooltip>
                        </th>
                        <th className="isPolyfuses text-capitalize font-weight-bolder opacity-7 ps-2">
                          Has polyfuses?
                        </th>
                        <th className="createdAt text-capitalize font-weight-bolder opacity-7 ps-2">
                          Created At
                           <Tooltip anchorSelect=".createdAt" className="tooltip-list " data-placement="top">
                           Displays the date and time when the machine was last logged into the portal.
                          </Tooltip>
                        </th>
                        <th className="LastUpdatedBy text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Updated By
                           <Tooltip anchorSelect=".LastUpdatedBy" className="tooltip-list " data-placement="top">
                           Last machine details updated person's name 
                          </Tooltip>
                        </th>
                        <th className="retiredAt text-capitalize font-weight-bolder opacity-7 ps-2">
                          Retired At
                           <Tooltip anchorSelect=".retiredAt" className="tooltip-list " data-placement="top">
                           Indicates if the machine has gone out of commission and, if so, when this occurred.
                          </Tooltip>
                        </th>
                        <th className="retiredBy text-capitalize font-weight-bolder opacity-7 ps-2">
                          Retired By
                           <Tooltip anchorSelect=".retiredBy" className="tooltip-list " data-placement="top">
                           Identifies the smoodi team member who decommissioned the machine
                          </Tooltip>
                        </th>
                        <th className="blender text-capitalize font-weight-bolder opacity-7 ps-2">
                          Blender
                           <Tooltip anchorSelect=".blender" className="tooltip-list " data-placement="top">
                           Displays the version of the blender assembly installed in the machine
                          </Tooltip>
                        </th>
                        <th className="board text-capitalize font-weight-bolder opacity-7 ps-2">
                          Board
                           <Tooltip anchorSelect=".board" className="tooltip-list " data-placement="top">
                           Displays the version of the adapter board installed in the machine
                          </Tooltip>
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Cup Holder
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                         Tube Shield
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                         Led Rings
                        </th>
                        <th className="lastSanitizeAt text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Sanitize At
                           <Tooltip anchorSelect=".lastSanitizeAt" className="tooltip-list " data-placement="top">
                           Date when the machine was last sanitized and logged to our system
                          </Tooltip>
                        </th>
                        <th className="lastHeartbeatAt text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Hearbeat At
                           <Tooltip anchorSelect=".lastHeartbeatAt" className="tooltip-list " data-placement="top">
                           the time when the machine was last connected to the Interne
                          </Tooltip>
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Sanitizer Replaced At
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Blade Replaced At
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Last Filter Replaced At
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Connection Status
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Is VIP
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                        Sanitizer Level
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Site Status
                        </th>
                        <th className="action text-capitalize font-weight-bolder opacity-7 ps-2">
                          Action
                           <Tooltip anchorSelect=".action" className="tooltip-list " data-placement="top">
                           Edit or change the status of the location
                          </Tooltip>
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      id="context-menu"
                    >
                      <li>
                        <button
                          className="dropdown-item editBtn" id="edit_record_link"
                        >
                          <i className="fa fa-pencil fs-6"></i>{" "}
                          <span className="ms-2">Edit</span>
                        </button>
                      </li>

                      <li>
                        {/* eslint-disable-next-line */}
                        <a className="dropdown-item" href="javascript:void(0)" id="view_record_link">
                          <i className="fa fa-eye f-6"></i>
                          <span className="ms-2"> View </span>
                        </a>
                      </li>
                      <li>
                        <button
                          className="dropdown-item qrCodeBtn" id="qrcode_record_link"
                        >
                          <i className="fa fa-qrcode fs-6"></i>{" "}
                          <span className="ms-2">Qr code</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item locationBtn" id="assignlocation_record_link"
                        >
                          <i className="fa-solid fa-location-dot fs-6"></i>{" "}
                          <span className="ms-2">Assign location</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item changeLocationBtn" id="changelocation_record_link"
                        >
                          <i className="fa fa-exchange"></i>{" "}
                          <span className="ms-2">Change Location</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item viewStatusBtn"
                          id="viewStatus_record_link"
                        >
                          <i className="fa fa-display f-6"></i>
                          <span className="ms-2">View Status</span>
                        </button>
                      </li>
                      <li>  
                        {/* eslint-disable-next-line */}
                        <a className="dropdown-item" href="javascript:void(0)" id="createTicket_record_link">
                          <i className="fa fa-ticket f-6"></i>
                          <span className="ms-2"> Create Ticket </span>
                        </a>
                      </li>
                    </ul>
                    <EditMachine
                      currentMachineId={this.state.currentMachineId}
                      machineEditModal={this.state.machineEditModal}
                      handleCloseMachine={this.handleCloseMachine}
                      refreshTable={this.refreshTable}
                    />
                    <ChangeLocationModal
                      changeLocationModal={this.state.changeLocationModal}
                      handleCloseChangeLocation={this.handleCloseChangeLocation}
                      currentMachineId={this.state.currentMachineId}
                      refreshTable={this.refreshTable}
                    />
                    <BarCodeModal
                      barCodeModal={this.state.barCodeModal}
                      handleCloseBarCode={this.handleCloseBarCode}
                      machineName={ this.state.machineName}
                      machineSerialNumber={this.state.serialNumber}
                    />
                    <AssignLocationModal
                      assignLocationModalOpen={this.state.assignLocationModalOpen}
                      handleCloseAssignLocation={this.handleCloseAssignLocation}
                      refreshTable={this.refreshTable}
                      currentMachineId={this.state.currentMachineId}
                    />
                    <ViewStatusModel
                      viewStatusModelOpen={this.state.viewStatusModelOpen}
                      handleCloseViewStatus={this.handleCloseViewStatus}
                      currentMachineId={this.state.currentMachineId}
                      refreshTable={this.refreshTable}
                    />

                </div>
              </div>
            </div>
          </div>
        </div>
        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </>
    );
  }
}

export default MachinesList;